import React from "react";
import { SyncBadge, PlanBadge, ScanModeBadge } from "./badges";

const TemplateListItem = ({ template, syncStatus, isSelected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`px-4 py-3 border-b border-border-subtle cursor-pointer transition-all ${
        isSelected
          ? "bg-accent-purple/5 border-l-[3px] border-l-accent-purple"
          : "border-l-[3px] border-l-transparent hover:bg-surface-neutral"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <h3 className={`text-body-sm font-semibold truncate ${isSelected ? "text-text-primary" : "text-text-primary"}`}>
            {template.title}
          </h3>
          <p className="text-body-xs text-text-tertiary truncate mt-0.5">
            {template.description || "No description"}
          </p>
        </div>
        <SyncBadge syncStatus={syncStatus} />
      </div>
      <div className="flex items-center gap-1.5 mt-2 flex-wrap">
        <ScanModeBadge mode={template.scan_mode} />
        <PlanBadge plan={template.plan_type} />
        <span className="text-caption text-text-tertiary">
          {template.prompts_count}p
          {template.test_cases_containers_count > 0 && ` ${template.test_cases_containers_count}tc`}
        </span>
        {template.automation_ready && (
          <span className="w-1.5 h-1.5 rounded-full bg-accent-green" title="Automation ready" />
        )}
      </div>
    </div>
  );
};

export default TemplateListItem;
